import { set_Terrassor_INTERFACE, get_Terrassor_INTERFACE, Terrassor_RECALCULATE } from "../../../../interface.js"; 

/* @ngInject */
export class EditEchelonController {
  /* @ngInject */
  constructor (ApiConst, ApiSimu, ApiExo, $scope, $filter, $q) {
    this.ApiConst = ApiConst
    this.ApiSimu = ApiSimu
    this.ApiExo = ApiExo
    this.$q = $q
    this.$scope = $scope
      /*
    this.tabIconesDel = [];
    this.tabIconesDel[0] = 1;*/
      this.toto = 1;

    this.hideAddEngin = this.hideAddEngin.bind(this)

    this.refreshEchelon = this.refreshEchelon.bind(this) // méthode appelable depuis <add-engin>

    this.ignore =  this.ignore.bind(this) // lorsqu'on veut ignorer un binding sur add-engin
  }

  $onInit () {

      console.log('EditEchelonController : init')

    this.echelon = this.resource
    if(!this.echelon) {
      console.log('EditEchelonController::$onInit, pas d\'echelon défini !!!')
      return
    }

    // vérif binding sur MouvementController.removeEchelon  
    if (!this.doRemoveEchelon) return console.error(`'edit-echelon' doit avoir un attribut do-remove-echelon"`)

    this.isAddingEngin = false
    this.allPhases = []
    this.formattedEnginsList = []
    console.log('EditEchelonController::onInit, mouvement, echelon', this.codemouvement, this.mouvement, this.echelon)

    this.refreshEnginsList(this.echelon)

   
    
  }

/*
* Alias pour binding depuis <add-engin>
*/
  refreshEchelon() {
    console.log('calling EditEchelonController::refreshEnginsList', this.echelon)
    this.hideAddEngin() // masquer le formulaire d'ajout

    return(this.refreshEnginsList(this.echelon)) // reconstruire la liste
    .then(_ => {      
  /*    var retour = Terrassor_RECALCULATE();
      if(retour.retour == true || retour.retour == "true") {
        this.parentSimulator.setPropertiesForPanelChantier()
        this.parentSimulator.setPropertiesForPanelCubature()
      }
*/
        this.parentMouvement.doOnChangeMouvement() // mouvement modifé, à invalider
        return this.echelon
    })
  }

/*
* definition de this.formattedEnginsList pour la vue
*/
  refreshEnginsList(echelon) {
     // Todo, faire une fonction indépendante, réutilisable pour un refreshEnginsList
    return this.getAllEnginsByPhase(echelon)
    .then( engins => {
      this.allEngins = engins  
      return this.ApiConst.getAllPhases()
    })
    .then(phases => {
      this.allPhases = phases
      this.addImageEngins(this.allEngins)
      this.formattedEnginsList = this.formatEnginsList(this.allEngins, this.allPhases)
      console.log('EditEchelonController::refreshEnginsList, formattedEnginsList', this.formattedEnginsList)


      var retour = Terrassor_RECALCULATE();
      if(retour.retour == true || retour.retour == "true") {
        this.parentSimulator.setPropertiesForPanelChantier()
        this.parentSimulator.setPropertiesForPanelCubature()
      }
      
      return this.echelon.formattedEnginsList = this.formattedEnginsList

    })

  }

/*
* // pour contourner le binding sur do-add-echelon qui ne sert à rien quand <add-engin> est child de <edit-echelon>
*/
  ignore(obj) {console.log('EditEchelonController::ignore', obj)} 

/*
* Toggle du panneau add-engin
*/
  showAddEngin () {

    if (this.mouvement.simuMouvement.commence) // BC 2017/12 bidouille mais pas compris structure de données RA
        return;

    this.isAddingEngin = true
  }

  hideAddEngin () {
    this.isAddingEngin = false
    this.selectedEngin = undefined
    this.selectedEnginIndex = undefined
  }

cacherMontrerImage(thisId) {
    /**/
    $(thisId+" img.montrer").addClass( "tmp" );
    $(thisId+" img.montrer").removeClass( "montrer" );
    $(thisId+" img.cacher").addClass( "montrer" );
    $(thisId+" img.cacher").removeClass( "cacher" );
    $(thisId+" img.tmp").addClass( "cacher" );
    $(thisId+" img.tmp").removeClass( "tmp" );
    /**/
    return(1);
}
  /*
  * Suppression de tous les engins d'un groupe. Raffraichissement de la liste après coup (on pourrait s'en passer en manipulant directement 
  * formattedEnginsList ... et travgailler dans la vue avec la phase et un $index
   */
choisirDeleteGroupEngins(phase,groupEngins) {

    if (this.mouvement.simuMouvement.commence) // BC 2017/12 bidouille mais pas compris structure de données RA
        return;


    // on change le bouton
    //var thisId = "#del_"+phase.nom+"_"+groupEngins.const_engins_code;
    var numEchelon = this.echelon.ordre; // BC 2018/04 Les id ne sont pas uniques !!!!!!! Bug si plusieurs echelons :-(
    var thisId = "#del_"+numEchelon+"_"+phase.nom+"_"+groupEngins.const_engins_code; // BC 2018/04 Les id ne sont pas uniques !!!!!!! Bug si plusieurs echelons :-( -----> on ajoute le num d'echelon dans l'id
    this.cacherMontrerImage(thisId);

    var promise = Promise.resolve(thisId)  // pour redonner la main à angular
    .then(_ => {

        $(".detruire-engin").addClass( "cacher" );

        var totalEngins = 0;
        groupEngins.engins.forEach(engin => {
            totalEngins ++;
        })
        if (totalEngins == 1) {
            var retour = this.deleteGroupEngins(phase,groupEngins);
            this.cacherMontrerImage(thisId);
            return(retour);
        }
        else {
        //var id = "#"+phase.nom+"_"+groupEngins.const_engins_code;
        var id = "#"+numEchelon+"_"+phase.nom+"_"+groupEngins.const_engins_code; // BC 2018/04 Les id ne sont pas uniques !!!!!!! Bug si plusieurs echelons :-( -----> on ajoute le num d'echelon dans l'id
        $(id).removeClass( "cacher" );
        }
    })
}

choisirDeleteGroupEnginsNo (phase,groupEngins) {
    //var thisId = "#del_"+phase.nom+"_"+groupEngins.const_engins_code;
    var numEchelon = this.echelon.ordre; // BC 2018/04 Les id ne sont pas uniques !!!!!!! Bug si plusieurs echelons :-(
    var thisId = "#del_"+numEchelon+"_"+phase.nom+"_"+groupEngins.const_engins_code; // BC 2018/04 Les id ne sont pas uniques !!!!!!! Bug si plusieurs echelons :-( -----> on ajoute le num d'echelon dans l'id

    //var id = "#"+phase.nom+"_"+groupEngins.const_engins_code;
    var id = "#"+numEchelon+"_"+phase.nom+"_"+groupEngins.const_engins_code; // BC 2018/04 Les id ne sont pas uniques !!!!!!! Bug si plusieurs echelons :-( -----> on ajoute le num d'echelon dans l'id
    $(id).addClass( "cacher" );
    this.cacherMontrerImage(thisId);
  }
choisirDeleteGroupEnginsYes (phase,groupEngins) {
    var retour;
    //var thisId = "#del_"+phase.nom+"_"+groupEngins.const_engins_code;
    var numEchelon = this.echelon.ordre; // BC 2018/04 Les id ne sont pas uniques !!!!!!! Bug si plusieurs echelons :-(
    var thisId = "#del_"+numEchelon+"_"+phase.nom+"_"+groupEngins.const_engins_code; // BC 2018/04 Les id ne sont pas uniques !!!!!!! Bug si plusieurs echelons :-( -----> on ajoute le num d'echelon dans l'id

    var selectionnes = 0;
    groupEngins.engins.forEach(engin => {
        if (engin.selected) {
            selectionnes ++;
        }
    })

    if (selectionnes == 0) {
        retour = alert(phase.nom+" : Vous devez sélectionner au moins un engin pour le retirer de l'échelon.");
        return(retour);

    }

    var messageConfirmation = phase.nom+" : Vous allez retirer "+selectionnes+" "+groupEngins.modelEngin.const_famillesengins_nom+" de l'échelon.\nEtes-vous sûr de vouloir réaliser cette opération ?";
    if(!confirm(messageConfirmation)) {
        //this.cacherMontrerImage(thisId);
        return;
    }
    this.cacherMontrerImage(thisId);

    //var id = "#"+phase.nom+"_"+groupEngins.const_engins_code;
    var id = "#"+numEchelon+"_"+phase.nom+"_"+groupEngins.const_engins_code; // BC 2018/04 Les id ne sont pas uniques !!!!!!! Bug si plusieurs echelons :-( -----> on ajoute le num d'echelon dans l'id

    $(id).addClass( "cacher" );
    $(thisId).html('<img src="images/icon_delete.svg">');

    // et on détruit les engins selectionnés
    var allPromises = []
    groupEngins.engins.forEach(engin => {
        if (engin.selected) {
            var promise = this.deleteEngin(engin)
            allPromises.push(promise)
        }
    })
    // raffraichir une fois que toutes les queries sont résolues
    return Promise.all(allPromises)
    .then(allResults => {
      return this.refreshEchelon()
    })
    .then( _ => {
      console.log('EditEchelonController::refreshEnginsList done', this.formattedEnginsList)
      if(this.formattedEnginsList.length == 0)
        return this.doRemoveEchelon(this.echelon)    //  appel de  MouvementController::remove
    })
  }

  deleteGroupEngins (phase, groupEngins) {
    //if(!confirm('Cette action va enlever ce groupe d\'engins de l\'échelon.\nEtes-vous sûr de vouloir réaliser cette opération ?')) {
    if(!confirm(phase.nom+" : Vous allez retirer 1 "+groupEngins.modelEngin.const_famillesengins_nom+" de l'échelon.\nEtes-vous sûr de vouloir réaliser cette opération ?")) {
        return;
    }
    console.log('EditEchelonController::deleteGroupEngins asked', groupEngins)

    var allPromises = []
    groupEngins.engins.forEach(engin => {
        var promise = this.deleteEngin(engin)
        allPromises.push(promise)
    })
    // raffraichir une fois que toutes les queries sont résolues  
    return Promise.all(allPromises)
    .then(allResults => {
      return this.refreshEchelon()
    })
    .then( _ => {
      console.log('EditEchelonController::refreshEnginsList done', this.formattedEnginsList)
      if(this.formattedEnginsList.length == 0)
        return this.doRemoveEchelon(this.echelon)    //  appel de  MouvementController::remove
    })

  }
    /*
    * Suppression d'un seul engin
    */
deleteLeEngin(engin) {

    if(!confirm('Cette action va enlever l\'engin de l\'échelon.\nEtes-vous sûr de vouloir réaliser cette opération ?')) {
        return;
    }

    console.log('EditEchelonController::deleteLeEngin asked', engin)

    var allPromises = []
    var promise = this.deleteEngin(engin) // une seule ;-)
    allPromises.push(promise)

    // raffraichir une fois que toutes les queries sont résolues
    return Promise.all(allPromises)
    .then(allResults => {
      return this.refreshEchelon()
    })
    .then( _ => {
      console.log('EditEchelonController::refreshEnginsList done', this.formattedEnginsList)
      if(this.formattedEnginsList.length == 0)
        return this.doRemoveEchelon(this.echelon)    //  appel de  MouvementController::remove
    })
}

/*
* suppression dans le DB; tient compte des engins réutiliss sur plusieurs mouvements / echelons
*/
deleteEngin (engin) {

    return this.ApiSimu.deleteEngin(engin)  
  }


  /*
  * jointure sur les engins et leurs options, par phase
  */
  getAllEnginsByPhase(echelon) {
    return this.ApiSimu.getEnginsPhasesOptions(echelon)
    .then(engins => {
      console.log('EditEchelonController::getAllEnginsByPhase for echelon, result', echelon, engins)
      return engins
    })
  }

addImageEngins(engins) {
  engins.forEach(e => {
    var famille = e.const_famillesengins_code
    var src = 'images/engins/' + famille.toLowerCase() + '_grey.svg'

    e.image = src
  })

}

/*
* réorganise la liste des engins par phase i.e. enginsPhases['PREP'] = {engin1}, {engin2}
* puis, pour chaque phase regoupe tous les engins de même type
*/
  formatEnginsList(engins, allPhases) {

    var enginsPhases = []

    allPhases.forEach(phase => {
      var code = phase.code
      var onePhase = {}

      onePhase.nom = phase.nom
      onePhase.engins = engins.filter(e => e.const_phases_code == code)
      if(onePhase.engins && onePhase.engins.length > 0) // on ne liste que les phases ayant des engins
        enginsPhases.push(onePhase)

    })
    
    // dupliquer cette liste en un regroupement par type (on garde les 2 représentations (engins & groupeEngins), on sait jamais)
    enginsPhases.forEach(eP => {
      var groupedEngins = this.groupEnginsByType(eP.engins)
      eP.groupedEngins = groupedEngins
    })
    return enginsPhases

  }

/*
* Les engins de même type sont regroupés visuellement. Donc on crée des objets correspondants
* {code-engin, engins[], nb_engins, modele} : Le modèle est utilisé pour les valeurs à afficher (c'est en fait une copie du premier de la liste)
*/
  groupEnginsByType(engins) {
    var groups = [];
    engins.forEach(e=> {

      this.addAgendaEngin(e)
        // ajout nelle entrée  (type-option-godet)
        var code = e.const_engins_code + '_opt_' + e.const_options_id + '_g_' + e.const_godets_id
        //var code = e.const_engins_code
        if(!groups[code]) {
            groups[code] = {'const_engins_code': code, 'engins' : [], 'nb' : 0}
          }
        groups[code].engins.push(e)
        groups[code].nb += 1
    })

    var groupedEngins = [] 
    // transform associative en indexed (sinon on ne peut pas le manipuler aisément dans la vue)
    for( var key in groups) {
      var g = groups[key]
      var item = {'const_engins_code' : g.const_engins_code, 'nb' : g.nb, 'engins':g.engins, 'modelEngin':g.engins[0]  }
      // libelles des options et godets
      this.addOptionsNames(item.modelEngin)
      groupedEngins.push(item)
    }

    return groupedEngins
  }

  addOptionsNames(modelEngin) 
  {
    modelEngin.optionName = this.ApiConst.getOptionName(modelEngin.const_options_id)
    modelEngin.godetName = this.ApiConst.getGodetName(modelEngin.const_godets_id)
  }


addAgendaEngin(e) {
  var retour, result

retour = get_Terrassor_INTERFACE().action({"table":"simu_engins", "agenda":{"id": e.simu_engins_id}})
if(retour.retour == false)
  return;
result = retour.objet

e.agenda = result;

}


  getPhaseName (phaseCode) {
    let phase = this.allPhases.filter(phase => phase.code === phaseCode).pop()
    let hasFoundPhase = phase && phase.nom
    return hasFoundPhase ? phase.nom : undefined
  }

  getEnginName (engin) {
    return engin.engin
  }


}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/edit-echelon/edit-echelon.controller.js